import { render, staticRenderFns } from "./reasonMoudel.vue?vue&type=template&id=38a3cead"
import script from "./reasonMoudel.vue?vue&type=script&lang=js"
export * from "./reasonMoudel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports